<template>
  <div class="fortuneItem">
    <div class="head">
      <img :src="imagePath" />
      <div class="right">
        <p>{{ title }}</p>
        <StatusLabel class="status" v-if="paymentStatus" :status="paymentStatus" />
      </div>
    </div>
    <p v-if="body" class="description">
      {{ body }}
    </p>
  </div>
</template>

<script>
import StatusLabel from './StatusLabel'
export default {
  name: 'FortuneItem',
  components:{
    StatusLabel
  },
  props: {
    imagePath: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    body: {
      type: String,
      default: '',
    },
    paymentStatus: {
      type: Number,
      default: 0,
    },
  },

  methods: {},
}</script>

<style lang="scss" scoped>
@import "../../../../../sass/commons/commonVariables.scss";
.fortuneItem {
  padding: 0 16px;
  .head {
    display: flex;
    align-items: center;
    img {
      width: 87px;
      margin-right: 12px;
      border-radius: 100%;
    }
    font-weight: bold;
    font-size: 16px;
    line-height: 23px;
    word-break: break-word;
  }
  .right{
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    height: 77px;
  }
  .status{
  }
  .description {
    margin-top: 11px;
    font-size: 14px;
    line-height: 24px;
  }
}
p {
  margin: 0
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ChounDiary/partials/FortuneItem.vue